import Vue from 'vue';
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';

// 初期化コスト分散
setTimeout(() => {
  /**
   * Sentry: Application Monitoring and Error Tracking Software
   * @see https://docs.sentry.io/platforms/javascript/guides/vue/
   */
  Sentry.init({
    Vue,
    dsn:
      process.env.NODE_ENV === 'local'
        ? ''
        : 'https://e880a0723d8440b3a26d8622842b2cf8@o550706.ingest.sentry.io/5674225', // localでは無効化
    integrations: [new Integrations.BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.016,

    // Custom settings
    environment: process.env.NODE_ENV,
    logErrors: process.env.NODE_ENV !== 'production', // production環境以外ではエラーをconsleにも出力する
    ignoreErrors: [
      'The access token expired',
      'Failed to fetch',
      'Network Error',
      'Invalid "exp" value in ID_TOKEN',
      'The access token revoked',
    ],
  });
}, 0);
